import { Component } from '@angular/core';
import { DynamicFormDto } from '../../../service/dto';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpMemberService } from '../../../service/http-member.service';
import { FormResult } from '../../../components/dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-member-form',
  standalone: false,
  templateUrl: './member-form.component.html',
  styleUrl: './member-form.component.scss'
})
export class MemberFormComponent {
	data?: DynamicFormDto;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private httpService: HttpMemberService) { }

	ngOnInit(): void {
		const id = this.activatedRoute.paramMap.subscribe(paramMap => {
			const id = paramMap.get('memberId');
			if (id) {
				this.httpService.get(+id).subscribe(result => {
					this.data = result;
				});
			} else {
				this.httpService.getForm().subscribe(result => {
					this.data = result;
				});
			}
		});
	}
	doHandleResult(input: FormResult){
		if(input.type == 'Cancel'){
			this.router.navigate(['/member','list']);
			return;
		}
		(this.data?.id ? (this.httpService.edit(this.data.id, input.data)) : (this.httpService.create(input.data))).subscribe(result => {
			this.router.navigate(['/member','list']);
		});
	}
}
